<template>
	<div
		class="flex fixed z-30 left-0 top-0 h-dvh w-screen"
		:class="{
			invisible: isMenuInvisible,
		}"
	>
		<button
			class="absolute size-full transition-all duration-150"
			:class="{
				'bg-black/35 backdrop-blur': isOpen,
				'bg-black/0': !isOpen,
			}"
			@click="close"
		>
			<span class="sr-only">Sluiten</span>
		</button>
		<Transition name="slide-in-left">
			<div
				v-if="isOpen"
				class="relative w-[90vw] bg-gradient-to-br from-purple-700 to-purple-900 py-12 flex flex-col justify-stretch shadow-2xl border-r-2 border-purple-900/10"
			>
				<div class="px-8 flex justify-between items-center mb-12">
					<AtomTitle
						tag="h2"
						size="md"
						class="uppercase text-white/50 tracking-widest"
					>
						Navigatie
					</AtomTitle>
					<button
						class="size-12"
						@click="close"
					>
						<AtomFontAwesome
							class="text-white/50 size-6"
							icon="fa-xmark"
						/>
					</button>
				</div>
				<div class="grow text-white relative">
					<div class="absolute size-full overflow-y-scroll hide-scrollbars pb-24">
						<div class="flex flex-col gap-4">
							<MenuItem
								v-for="item in menuItems"
								:key="`mobileMenuItem-${item.to.url}`"
								:item
								@navigate="close"
							/>
						</div>
					</div>
				</div>
				<div>
					<div class="relative pointer-events-none">
						<div class="bg-gradient-to-b from-purple-900/0 to-purple-900 h-24 absolute size-full -mt-24" />
					</div>
					<div class="flex flex-col gap-4">
						<div class="border-t border-purple-50/10 flex justify-end gap-8 px-8 pt-2">
							<AtomLink
								v-for="item of serviceMenuItems"
								:key="`service-menu-item-${item.to.url}`"
								v-bind="item.to"
								class="text-brand-200 text-functional-size-xs uppercase tracking-wide hover:bg-purple-800 touch:h-16 cursor:h-12 flex items-center px-2 sm:px-5 gap-2"
							>
								<AtomFontAwesome :icon="item.icon" />
								<span>{{ item.text }}</span>
							</AtomLink>
						</div>
						<div class="grid grid-cols-2 gap-4 px-4">
							<AtomLink
								:url="`tel:${internationalPhoneNumber}`"
								title="Telefonisch contact"
								new-tab
								class="text-white/90 relative flex items-center justify-center bg-gradient-to-tr from-purple-700 to-purple-600 shadow rounded h-16"
							>
								<AtomFontAwesome
									icon="fa-phone"
									class="size-6 absolute left-4"
								/>
								<span class="text-functional-size-sm lowercase tracking-widest pl-5 shadow-sm">Bellen</span>
							</AtomLink>
							<AtomLink
								:url="mapsUrl"
								title="Telefonisch contact"
								new-tab
								class="text-white/90 relative flex items-center justify-center bg-gradient-to-tr from-purple-700 to-purple-600 shadow rounded h-16"
							>
								<AtomFontAwesome
									icon="fa-map-location"
									class="size-6 absolute left-4"
								/>
								<span class="text-functional-size-sm lowercase tracking-widest pl-5 shadow-sm">Navigeren</span>
							</AtomLink>
						</div>
					</div>
				</div>
			</div>
		</Transition>
	</div>
</template>

<script lang="ts" setup>
import MenuItem from './MenuItem.vue';
import { internationalPhoneNumber, mapsUrl } from '#base/core/consts/companyData';
import type { MainMenuItemType } from '#base/core/types/MainMenuItemType';
import type { SubHeaderMenuItemType } from '#base/core/types/SubHeaderMenuItemType';

const {
	isOpen = false,
	menuItems,
} = defineProps<{
	isOpen?: boolean;
	menuItems: MainMenuItemType[];
	serviceMenuItems: SubHeaderMenuItemType[];
}>();

const emit = defineEmits(['close', 'clickAppointmentButton']);
const close = () => emit('close');

const isMenuInvisible = ref<boolean>(true);

watch(() => isOpen, () => {
	const isMenuInvisibleDelay = isOpen ? 0 : 250;
	setTimeout(() => isMenuInvisible.value = !isOpen, isMenuInvisibleDelay);
});
</script>
